import React, { PureComponent } from "react";
import AbbreviatedMillionNumberFormat from "../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

class VarianceAnalysisWidget extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      totalRevenuesExpanded: true,
      totalCostOfSalesExpanded: true,
      grossProfitsExpanded: true,
      netProfitsExpanded: true
    };
  }

  expandTotalCostOfSales = () => {
    this.setState({
      totalCostOfSalesExpanded: true
    });
  };

  collapseTotalCostOfSales = () => {
    this.setState({
      totalCostOfSalesExpanded: false
    });
  };

  expandTotalRevenues = () => {
    this.setState({
      totalRevenuesExpanded: true
    });
  };

  collapseTotalRevenues = () => {
    this.setState({
      totalRevenuesExpanded: false
    });
  };

  expandGrossProfits = () => {
    this.setState({
      grossProfitsExpanded: true
    });
  };

  collapseGrossProfits = () => {
    this.setState({
      grossProfitsExpanded: false
    });
  };

  expandNetProfits = () => {
    this.setState({
      netProfitsExpanded: true
    });
  };

  collapseNetProfits = () => {
    this.setState({
      netProfitsExpanded: false
    });
  };

  getActualYearParam(key) {
    const { actual, current_year } = this.props;

    if (current_year in actual) {
      let obj = actual[current_year];
      if (key in obj) {
        return obj[key];
      }
    }

    return 0;
  }

  getExpectedYearParam(key) {
    const { expected, current_year } = this.props;

    if (current_year in expected) {
      let obj = expected[current_year];
      if (key in obj) {
        return obj[key];
      }
    }

    return 0;
  }

  getDiffYearParam(key, before, after) {
    before = before || this.getExpectedYearParam(key);
    after = after || this.getActualYearParam(key);

    if (before === 0 || after === 0) {
      return 0;
    }

    const percent = ((after - before) / Math.abs(before)) * 100;

    return percent.toFixed(2);
  }

  /**
   * Expected values
   */
  get expectedUnits() {
    return Math.abs(this.getExpectedYearParam("units_sold"));
  }

  get expectedAvgSellingPrice() {
    return this.getExpectedYearParam("average_selling_price");
  }

  get expectedTotalRevenues() {
    return this.getExpectedYearParam("total_revenues");
  }

  get expectedAvgUnitCosts() {
    return this.getExpectedYearParam("average_unit_costs");
  }

  get expectedTotalCostOfSales() {
    return this.getExpectedYearParam("total_cost_goods_sold");
  }

  get expectedGrossProfits() {
    return this.getExpectedYearParam("gross_profits");
  }

  get expectedOperatingExpenses() {
    return (
      this.getExpectedYearParam("total_operating_costs") +
      this.getExpectedYearParam("total_non_operating_costs")
    );
  }

  get expectedNonOperatingExpenses() {
    return this.getExpectedYearParam("total_non_operating_costs");
  }

  get expectedTotalIncomeBeforeTaxes() {
    return this.getExpectedYearParam("income_before_taxes");
  }

  get expectedNetProfits() {
    return this.getExpectedYearParam("net_income");
  }

  /**
   * Actual values
   */
  get actualUnits() {
    return Math.abs(this.getActualYearParam("units_sold"));
  }

  get actualAvgSellingPrice() {
    return this.getActualYearParam("average_selling_price");
  }

  get actualTotalRevenues() {
    return this.getActualYearParam("total_revenues");
  }

  get actualAvgUnitCosts() {
    return this.getActualYearParam("average_unit_costs");
  }

  get actualTotalCostOfSales() {
    return this.getActualYearParam("total_cost_goods_sold");
  }

  get actualGrossProfits() {
    return this.getActualYearParam("gross_profits");
  }

  get actualOperatingExpenses() {
    return (
      this.getActualYearParam("total_operating_costs") +
      this.getActualYearParam("total_non_operating_costs")
    );
  }

  get actualNonOperatingExpenses() {
    return this.getActualYearParam("total_non_operating_costs");
  }

  get actualTotalIncomeBeforeTaxes() {
    return this.getActualYearParam("income_before_taxes");
  }

  get actualNetProfits() {
    return this.getActualYearParam("net_income");
  }

  /**
   * Diff values
   */
  get diffUnits() {
    return this.getDiffYearParam(
      null,
      null,
      this.expectedUnits,
      this.actualUnits
    );
  }

  get diffAvgSellingPrice() {
    return this.getDiffYearParam("average_selling_price");
  }

  get diffTotalRevenues() {
    return this.getDiffYearParam("total_revenues");
  }

  get diffAvgUnitCosts() {
    return -1 * this.getDiffYearParam("average_unit_costs");
  }

  get diffTotalCostOfSales() {
    return this.getDiffYearParam("total_cost_goods_sold");
  }

  get diffGrossProfits() {
    return this.getDiffYearParam("gross_profits");
  }

  get diffOperatingExpenses() {
    return this.getDiffYearParam(
      null,
      null,
      this.expectedOperatingExpenses,
      this.actualOperatingExpenses
    );
  }

  get diffNonOperatingExpenses() {
    return this.getDiffYearParam("total_non_operating_costs");
  }

  get diffTotalIncomeBeforeTaxes() {
    return this.getDiffYearParam("income_before_taxes");
  }

  get diffNetProfits() {
    return this.getDiffYearParam("net_income");
  }

  render() {
    const { current_year } = this.props;

    return (
      <div className="panel-dashboard-white-full team-reports-with-scroll">
        <h5 className="title-sky-blue">VARIANCE ANALYSIS</h5>
        <div className="table-responsive team-reports-hide-scroll">
          <table className="table border-analysis mb-20">
            <thead>
              <tr>
                <th className="table-title text-center">
                  <span></span>
                </th>
                <th className="table-title text-center title-sky-blue">
                  <span>YEAR {current_year}</span>
                  <span className="block">(CURRENT YEAR)</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-center">
                <th className="sub-title title-sky-blue"></th>
                <td>
                  <div className="row flex">
                    <div className="col-xs-4">Expected</div>
                    <div className="col-xs-4">Actual</div>
                    <div className="col-xs-4 make-it-bolder">Diff</div>
                  </div>
                </td>
              </tr>
              {this.state.grossProfitsExpanded === true && (
                <tr className="text-center">
                  <th className="sub-title title-sky-blue">Revenues</th>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4 make-it-bolder">&nbsp;</div>
                    </div>
                  </td>
                </tr>
              )}
              {this.state.grossProfitsExpanded === true &&
                this.state.totalRevenuesExpanded === true && (
                  <tr className="text-center">
                    <th className="description">Units</th>
                    <td>
                      <div className="row flex">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedUnits}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualUnits}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffUnits}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              {this.state.grossProfitsExpanded === true &&
                this.state.totalRevenuesExpanded === true && (
                  <tr className="text-center">
                    <th className="description">Average Selling Price</th>
                    <td>
                      <div className="row flex">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedAvgSellingPrice}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualAvgSellingPrice}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffAvgSellingPrice}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              {this.state.grossProfitsExpanded === true && (
                <tr className="text-center bg-gray none-shadow">
                  <th className="description">
                    <strong>Total Revenues</strong>
                    {this.state.totalRevenuesExpanded === false ? (
                      <span
                        className="fn-analysis-plus"
                        onClick={this.expandTotalRevenues}
                      >
                        +
                      </span>
                    ) : (
                      <span
                        className="fn-analysis-minus"
                        onClick={this.collapseTotalRevenues}
                      >
                        -
                      </span>
                    )}
                  </th>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedTotalRevenues}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualTotalRevenues}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffTotalRevenues}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              {this.state.grossProfitsExpanded === true && (
                <tr className="text-center">
                  <th className="sub-title title-sky-blue">Cost of Sales</th>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4"></div>
                      <div className="col-xs-4 make-it-bolder">&nbsp;</div>
                    </div>
                  </td>
                </tr>
              )}
              {this.state.grossProfitsExpanded === true &&
                this.state.totalCostOfSalesExpanded === true && (
                  <tr className="text-center">
                    <th className="description">Units</th>
                    <td>
                      <div className="row flex">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedUnits}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualUnits}
                            prefix=""
                            negativeClass="title-red"
                            forceConvert={true}
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffUnits}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              {this.state.grossProfitsExpanded === true &&
                this.state.totalCostOfSalesExpanded === true && (
                  <tr className="text-center">
                    <th className="description">Average Unit Costs</th>
                    <td>
                      <div className="row flex">
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.expectedAvgUnitCosts}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4">
                          <AbbreviatedMillionNumberFormat
                            value={this.actualAvgUnitCosts}
                            prefix="$"
                            negativeClass="title-red"
                            hideZero={true}
                          />
                        </div>
                        <div className="col-xs-4 make-it-bolder">
                          <AbbreviatedMillionNumberFormat
                            value={this.diffAvgUnitCosts}
                            prefix=""
                            negativeClass="title-red"
                            suffix="%"
                            hideZero={true}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              {this.state.grossProfitsExpanded === true && (
                <tr className="text-center bg-gray none-shadow">
                  <th className="description">
                    <strong>Total Cost of Sales</strong>
                    {this.state.totalCostOfSalesExpanded === false ? (
                      <span
                        className="fn-analysis-plus"
                        onClick={this.expandTotalCostOfSales}
                      >
                        +
                      </span>
                    ) : (
                      <span
                        className="fn-analysis-minus"
                        onClick={this.collapseTotalCostOfSales}
                      >
                        -
                      </span>
                    )}
                  </th>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedTotalCostOfSales}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualTotalCostOfSales}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffTotalCostOfSales}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="text-center bg-gray none-shadow">
                <th className="description">
                  <strong>Gross Profits</strong>
                  {this.state.grossProfitsExpanded === false ? (
                    <span
                      className="fn-analysis-plus"
                      onClick={this.expandGrossProfits}
                    >
                      +
                    </span>
                  ) : (
                    <span
                      className="fn-analysis-minus"
                      onClick={this.collapseGrossProfits}
                    >
                      -
                    </span>
                  )}
                </th>
                <td>
                  <div className="row flex">
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.expectedGrossProfits}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.actualGrossProfits}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4 make-it-bolder">
                      <AbbreviatedMillionNumberFormat
                        value={this.diffGrossProfits}
                        prefix=""
                        negativeClass="title-red"
                        suffix="%"
                        hideZero={true}
                      />
                    </div>
                  </div>
                </td>
              </tr>
              {this.state.netProfitsExpanded === true && (
                <tr className="text-center">
                  <th className="description">Other Expenses</th>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedOperatingExpenses}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualOperatingExpenses}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffOperatingExpenses}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              {this.state.netProfitsExpanded === true && (
                <tr className="text-center bg-gray none-shadow">
                  <th className="description">
                    <strong>Total Income Before Taxes</strong>
                  </th>
                  <td>
                    <div className="row flex">
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.expectedTotalIncomeBeforeTaxes}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4">
                        <AbbreviatedMillionNumberFormat
                          value={this.actualTotalIncomeBeforeTaxes}
                          prefix="$"
                          negativeClass="title-red"
                          forceConvert={true}
                          hideZero={true}
                        />
                      </div>
                      <div className="col-xs-4 make-it-bolder">
                        <AbbreviatedMillionNumberFormat
                          value={this.diffTotalIncomeBeforeTaxes}
                          prefix=""
                          negativeClass="title-red"
                          suffix="%"
                          hideZero={true}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              <tr className="text-center bg-gray none-shadow">
                <th className="description">
                  <strong>Net Profits</strong>
                  {this.state.netProfitsExpanded === false ? (
                    <span
                      className="fn-analysis-plus"
                      onClick={this.expandNetProfits}
                    >
                      +
                    </span>
                  ) : (
                    <span
                      className="fn-analysis-minus"
                      onClick={this.collapseNetProfits}
                    >
                      -
                    </span>
                  )}
                </th>
                <td>
                  <div className="row flex">
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.expectedNetProfits}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4">
                      <AbbreviatedMillionNumberFormat
                        value={this.actualNetProfits}
                        prefix="$"
                        negativeClass="title-red"
                        forceConvert={true}
                        hideZero={true}
                      />
                    </div>
                    <div className="col-xs-4 make-it-bolder">
                      <AbbreviatedMillionNumberFormat
                        value={this.diffNetProfits}
                        prefix=""
                        negativeClass="title-red"
                        suffix="%"
                        hideZero={true}
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default VarianceAnalysisWidget;



// WEBPACK FOOTER //
// ./src/components/finance/widgets/variance-analysis.js